import {Lesson} from '@models/lesson';
import {Schedule} from '@models/schedule';

export class Curriculum {
  'id'?: number;
  'name': string;
   start_curriculum: string;
   end_curriculum: string;
  'image': string;
  'description': string;
  'lessons': any;
  'order'?: string;
  'program_id'?: number;
}
